// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610231842/js/" + chunkId + "." + {"44":"7c740942","225":"cc8c2197","481":"8efbe1af","486":"99bc3070","770":"9e682d16"}[chunkId] + ".0.25028620053960204.chunk.js";
};